<!-- Wenn kein Schlüssel gefunden wird, aus welchen Gründen auch immer, dann soll die Komponente nicht angezeigt werden. -->
<!-- Dann gibt gibt der Java-Service ein Optional.empty() zurück und die Konfiguration (this.configuration) wird nicht initialisiert -->
<!-- Aber Vorsicht: -->
<!-- Einige Code-Stellen wirden bereits aufgerufen, bevor this.configuration aufgerufen wird. -->
<!-- Siese müssen dann jeweils abgesichert werden.  -->
@if (configuration) {
<div [class]="fileUploadCss()">
  @if (helptextAbove()) {
  <div class="infoMessage"
       [innerHTML]="helptextAbove() | hisUi">
  </div>
  }
  @defer (when !supportLargeFiles || scriptLoaded) {
  @if (isShowUpload() ) {
  <div>
    <p-fileUpload #pFileUpload
                  [showUploadButton]="false"
                  [showCancelButton]="false"
                  mode="advanced"
                  [auto]="true"
                  [disabled]="isDisableFileUpload()"
                  [multiple]="isMultiple()"
                  [maxFileSize]="configuration.maxFileSize"
                  [accept]="configuration.accept"
                  [invalidFileTypeMessageSummary]="invalidFileTypeMessage()"
                  [invalidFileTypeMessageDetail]="''"
                  [invalidFileSizeMessageSummary]="invalidFileSizeMessage()"
                  invalidFileSizeMessageDetail=""
                  [customUpload]="true"
                  (uploadHandler)="uploadFiles($event)">
      <ng-template pTemplate="buttonbar">
        <div class="ui-fileupload-buttonbar"> </div>
      </ng-template>
      <ng-template let-file pTemplate="file">
        <!-- do not delete this ngTemplate -->
      </ng-template>
      <ng-template pTemplate="content">
        @if (!uploading) {
        <button #uploadButtonRef
                type="button"
                tabindex="0"
                class="upload-button"
                [title]="uploadButtonTitle"
                [ariaLabel]="uploadButtonAriaLabel"
                (click)="pFileUpload.choose()"
                (blur)="triggerValidation()">
          <em class="pi pi-cloud-upload"></em>
          <img hisImage="CHOOSE_FILE" class="inlineicon">
          <span>{{getInternalUploadFieldLabel()}}</span>
        </button>
        }
        @if (showValidationMessage()) {
        <div class="plamRow plamWarningtextContainer ui-g">
          <div class="plamWarningtextSpacer ui-g-12 ui-md-12 ui-lg-11 ui-xl-4"></div>
          <div class="plamWarningtext ui-g-12 ui-md-12 ui-lg-11 ui-xl-7" role="alert">
            {{'validation.required' | hisUi}}
          </div>
        </div>
        }&nbsp;
      </ng-template>
    </p-fileUpload>
  </div>
  }
  }
  @placeholder {
  <his-waiting-animation variant="default" />
  }
  @if ((model && model.length) || uploading) {
  <div id="uploadedFiles" class="uploaded-files-frame">
    @if (uploading) {
    <div class="upload-in-progress">
      {{ 'common.components.inputFile.uploadInProgress' | hisUi }}
    </div>
    }
    @if (supportLargeFiles && uploading) {
    <div class="upload-progress-container">
      <p-table [value]="uploadQueue" class="upload-progress-table">
        <ng-template pTemplate="body" let-uploadElement let-i="rowIndex">
          <tr>
            <td>{{ uploadElement.file.name }}</td>
            <td width="300px">
              @if (i === 0) {
              <p-progressBar [value]="uploadElement.progress" />
              }
            </td>
            <td class="upload-action-buttons">
              @if (i === 0) {
              @if (!uploadElement.paused) {
              <button type="button"
                      id="pauseUpload"
                      hisImage="PAUSE"
                      (click)="pauseUpload(uploadElement)"
                      [title]="'cs.sys.component.inputLargeFile.pauseUpload' | hisUi"
                      class="transparent"></button>
              } @else {
              <button type="button"
                      id="resumeUpload"
                      hisImage="NEXT"
                      (click)="resumeUpload(uploadElement)"
                      [title]="'cs.sys.component.inputLargeFile.resumeUpload' | hisUi"
                      class="transparent"></button>
              }
              }
              <button type="button"
                      id="cancelUpload"
                      hisImage="PANEL_CLOSE"
                      (click)="cancelUpload(uploadElement)"
                      [title]="'cs.sys.component.inputLargeFile.cancelUpload' | hisUi"
                      class="transparent"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    }
    @if (allAssignableConfigurationDmcValues().length > 1) {
    <his-plam [required]="true" label="{{'common.components.inputFile.commonCategory' | hisUi}}">
      @if (!categoryDisabled) {
      <div>
        <p-autoComplete
                        #content
                        #autocomplete
                        [required]="true"
                        [dropdown]="true"
                        optionLabel="defaulttext"
                        [ngModel]="selectedCategory()"
                        (ngModelChange)="onCategoryModelChange($event)"
                        [suggestions]="filteredCategories()"
                        (completeMethod)="filterDocumentMetadataCategories($event)"
                        (onSelect)="selectDocumentMetadataCategory($event)">
        </p-autoComplete>
      </div>
      }
      @if (categoryDisabled) {
      <div>
        @for (category of allAssignableConfigurationDmcValues(); track category) {
        <div #content>
          <span #content class="plamContentText">{{category.text}}</span>
        </div>
        }
      </div>
      }
    </his-plam>
    }
    @if (isShowCategoryIfUnique() && allAssignableConfigurationDmcValues().length === 1) {
    <his-plam [required]="true" label="{{'common.components.inputFile.commonCategory' | hisUi}}">
      <span #content class="plamContentText">{{allAssignableConfigurationDmcValues()[0].text}}</span>
    </his-plam>
    }
    <div class="{{showFilesSeparatorLine() ? 'uploaded-files-separator-line' : ''}}">
      @for (uploadFile of model; track uploadFile.uuid) {
      <div>
        <div>
          <button id="delete" hisImage="PANEL_CLOSE" class="transparent" (click)="remove(uploadFile)"
                  [title]="'common.removeOf' | hisUi: uploadFile.name"
                  [disabled]="deleteDisabled">
          </button>
          <!-- tabindex="-1": nur programmatisch fokussierbar, damit der Fokus nach dem Upload hierher wandern kann. -->
          <span tabindex="-1" [attr.data-file-uuid]="uploadFile.uuid">{{uploadFile.name}}</span>
          <his-upload-file-download [value]="uploadFile" [disabled]="downloadDisabled"></his-upload-file-download>
          @if (!disableFeedback() && getFeedback(uploadFile)) {
          <ul class="upload-feedback">
            @for (feedback of getFeedback(uploadFile); track feedback) {
            <li>
              <button
                      class="icon"
                      type="button"
                      [hisImage]="feedback.icon"
                      [title]="feedback.iconMessageKey| hisUi"
                      (click)="showFeedback($event, feedback)">
              </button>
            </li>
            }
            @if (feedbackPending(uploadFile) || (uploadFile.id && this.ongoingBatchFeedback)) {
            <li>
              <his-waiting-animation variant="small" [title]="'common.components.inputFile.feedback.pending' | hisUi" />
            </li>
            }
          </ul>
          }
          <p-overlayPanel
                          #feedbackPanel
                          [showCloseIcon]="true"
                          [dismissable]="true">
            <ng-template pTemplate>
              <div class="upload-feedback-content" [innerHTML]="feedbackPanelContent"></div>
            </ng-template>
          </p-overlayPanel>
        </div>
        @if (showDescription()) {
        <div>
          <his-plam label="{{'common.components.inputFile.resourceComment' | hisUi}}" [showLabelTop]="true">
            <textarea #content class="textareaWidth100"
                      [ngModel]="uploadFile.comment"
                      [disabled]="commentDisabled"
                      (ngModelChange)="onCommentChanged(uploadFile, $event)">
                    </textarea>
          </his-plam>
        </div>
        }
      </div>
      }
    </div>
  </div>
  }
  @if (helptextBelow()) {
  <div class="infoMessage"
       [innerHTML]="helptextBelow() | hisUi">
  </div>
  }
  <!--     Auswahlfeld für die Dokumentenkategorie unterhalb der Komponente -->
</div>
}